import { SubmissionError } from 'redux-form/immutable';
import { saveContactInfo } from '../../../services/API';
import { omit } from 'lodash';
import errorMessages from 'constants/errorMessages';

const codeWordRequired =
  'Контрольное слово обязательно для восстановления пароля по электронной почте';

export default async function submit(values, options) {
  let nextValues;

  if (values.allowRestoring && !values.codeWord && options && !options.hasCodeWord) {
    throw new SubmissionError({ _error: codeWordRequired });
  }

  nextValues = omit(values, ['sendEmail', 'needEmailVerify']);

  if (!(values.oldPassword || values.newPassword1 || values.newPassword2)) {
    nextValues = omit(nextValues, ['oldPassword', 'newPassword1', 'newPassword2']);
  }

  const response = await saveContactInfo(nextValues);

  return await validateResponse(response);
}

async function validateResponse(response) {
  if (!response.isOk && response.error.response.status === 400) {
    throw new SubmissionError(response.error.response.data);
  } else if (!response.isOk) {
    throw new SubmissionError({ _error: errorMessages.defaultServerError });
  }
}
